import SimpleThread from './SimpleThread';
import SimpleThreadContainer from './SimpleThread.container';

export default SimpleThreadContainer(SimpleThread);
export { type Props } from './SimpleThread';
